"use client"

import { VisionAndMissionProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import { twMerge } from "tailwind-merge"
import { generateResponsiveCSS } from "../../../lib/helper"
import { BottomSection } from "./components/BottomSection"
import { TopSection } from "./components/TopSection"

export const RenderConfig: ComponentConfig<VisionAndMissionProps> = {
  render: ({
    topImage,
    topItems,
    topDescriptions,
    bottomImage,
    visionTitle,
    visionDescription,
    missionTitle,
    missionDescription,
    companyValues,
    styles,
    responsiveType,
    className,
  }) => {
    const id = `vision-and-mission-${Math.random().toString(36).substr(2, 9)}`
    const mergedStyles = styles || {}
    const responsiveCSS = generateResponsiveCSS(id, mergedStyles, responsiveType || "mobileFirst")

    return (
      <>
        {responsiveCSS}
        <div
          id={id}
          className={twMerge(
            "container mx-auto max-w-[1260px] pt-[2.5rem] pb-0 px-4 sm:px-0 sm:pt-[6.25rem] sm:pb-0",
            id,
            className,
          )}
        >
          {/* Top Section - Image Left, Text Right */}
          <TopSection
            image={topImage}
            items={topItems}
            descriptions={topDescriptions}
            className="pb-[6.0625rem] sm:pb-[5rem]"
          />
        </div>

        {/* Bottom Section - Image Right, Text Left with #FAFAFB background */}
        <BottomSection
          image={bottomImage}
          visionTitle={visionTitle}
          visionDescription={visionDescription}
          missionTitle={missionTitle}
          missionDescription={missionDescription}
          companyValues={companyValues}
        />
      </>
    )
  },
}
